/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LineSpacingIcon = /*#__PURE__*/ createSvgIcon(
  'LineSpacingIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.3 4.75L2.87 2.32.42 4.77M.42 15.25l2.43 2.43 2.45-2.45M2.85 17.68V2.32M7.21 5.35H20M7.21 8.45h9.3M7.21 11.55H20M7.21 14.65h9.3"
            stroke="currentColor"
            strokeMiterlimit={10}
          />
        </>
      ),
    },
  },
  false
);

export default LineSpacingIcon;
